// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import NotificationFilledSvg from "@fishx/icons-svg/es/asn/NotificationFilled";
import FishxIcon from '../components/FishxIcon';

var NotificationFilled = function NotificationFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: NotificationFilledSvg
  }));
};

NotificationFilled.displayName = 'NotificationFilled';
export default React.forwardRef(NotificationFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/NotificationFilled.js
// module id = 3169
// module chunks = 0